var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2480",
    "data-name": "Group 2480",
    transform: "translate(319 -4736)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1582",
    "data-name": "Rectangle 1582",
    width: 15,
    height: 15,
    transform: "translate(-319 4736)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2465",
    "data-name": "Group 2465",
    transform: "translate(-319 4686)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1862",
    "data-name": "Group 1862",
    transform: "translate(0 51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M0,51V64H15V51ZM8.525,61.78H2.051v-.951H8.525Zm0-1.9H2.051v-.951H8.525Zm0-1.9H2.051v-.951H8.525Zm0-1.9H2.051v-.951H8.525Zm4.424,3.8H9.434V55.122h3.516ZM14.121,52.9H.879v-.951H14.121Z",
    transform: "translate(0 -51)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews);
export default __webpack_public_path__ + "static/media/news.53cd669ac1ba23d0e465856b39332e0e.svg";
export { ForwardRef as ReactComponent };